<template>
    <div class="">
        <div class="custom-loader-wrapper" v-if="loader">
            <div class="text-center">
                <span class="d-block max-450">We are processing your download and this may take some time. Do not close this window until the download begins.</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Please click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button class="mb-1" target="_blank" :href="$api_url+'/company/dashboard'">Dashboard</b-button>
            </div>
        </div>
        <div class="row mt-4 no-margin">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title px-0">
                    <h4 class="font-regular with-blue-text">Current Selected: <span>Individual Settlement Report</span></h4>
                </div>
                <div class="ibox-content px-0 trz_ppl_wrapper_2 mt-3">
                    <div v-if="custom_list.length > 0">
                        <common-list 
                            :action_btn_text="action_btn_text" 
                            :pageurl="this.$api_url" 
                            :is_pf="is_n_pf" 
                            :is_action="is_action" 
                            :appended_column="appended_column" 
                            :key="list_key" 
                            :company_options="company_options" 
                            :employees="custom_list" 
                            :default_column="default_column" 
                            :primary_key="primary_key" 
                            v-on:childToParent="listReturn">
                        </common-list>
                    </div>
                    <div v-else>
                        <div v-if="showoverlay" class="list-no-data">
                            <span class="d-block text-center">Looking for relevant data..</span>
                            <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                        </div>
                        <div v-else class="list-no-data">
                            Looks like there is no settled employee to show.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {},
    props: ['pageurl', 'flag', 'is_trustee'],
    data() {
        return {
            company_name: '',
            pageUrl: this.$api_url,
            showoverlay: true,
            loader: false,
            action_btn_text: 'Download Report',
            is_n_pf: 1,
            is_action: 0,
            list_key: 0,
            default_column: ['name', 'email', 'employee_code'],
            appended_column: [
                { value: "settlement_company_code", text: "Settlement Code", type: "text" },
                { value: "settlement_type", text: "Settlement Type", type: "text" },
                { value: "settlement_amount", text: "Settlement Amount", type: "amount" },
                { value: "settlement_date", text: "Settlement Date", type: "date" },
                { value: "settlement_status", text: "Status", type: "text" }
            ],
            primary_key: 'settlement_id',
            company_options: [],
            custom_list: []
        };
    },
    methods: {
        getSettlementListData() {
            let currentObj = this;
            this.showoverlay = true;
            axios.post(this.$api_url + '/pf/settlement/list', {
                list_type: 'all'
            }).then(function(response) {
                this.showoverlay = false;
                if (typeof response.data.employee_data !== 'undefined') {
                    this.custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                    this.company_options = response.data.options || [];
                    this.list_key += 1;
                }
            }.bind(this)).catch(function(error) {
                currentObj.showoverlay = false;
                console.log(error);
            });
        },
        listReturn(data) {
            let settlement_id = data.settlement_id || data.id;
            if (settlement_id > 0) {
                this.downloadIndividualSettlementPdf(settlement_id);
            }
        },
        downloadIndividualSettlementPdf(settlement_id) {
            if (!this.checkNet()) return false;
            this.loader = true;
            let formData = new FormData();
            formData.append('settlement_id', settlement_id);
            this.downloadBlobResponse(
                axios.post(this.$api_url + '/pf/settl-download-pdfbankfile', formData, { responseType: 'blob' }),
                'loader'
            );
        }
    },
    created() {
        this.getSettlementListData();
    }
};
</script>
